import React from "react";
import styled from "styled-components";

function TableComponent({ data }) {
  if (!data || !data.Forecast?.length) return null;

  const columns = Object.keys(data.Forecast[0]);

  const rowConfig = [
    { key: "Forecast", label: "Forecast" },
    { key: "Opening Inventory", label: "Opening Inventory" },
    { key: "Quantity to be ordered", label: "Quantity to be ordered" },
    {
      key: "Quantity to be ordered (EOQ)",
      label: "Quantity to be ordered post adjusting for EOQ and Safety Stock",
    },
    { key: "Closing Inventory", label: "Closing Inventory" },
  ];

  return (
    <Wrapper>
      <Card>
        <div className="table-container">
          <table className="inventory-table">
            <thead>
              <tr>
                <th className="header-left">UNITS \\ WEEKS</th>
                {columns.map((col) => (
                  <th key={col} className="header-cell">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rowConfig.map((row, idx) => {
                const rowData = data[row.key];
                if (!rowData || !Array.isArray(rowData)) return null;

                const isLast = idx === rowConfig.length - 2;

                return (
                  <tr key={row.key} className={isLast ? "highlight-row" : ""}>
                    <td className={`row-title ${isLast ? "highlight-title" : ""}`}>
                      {row.label}
                    </td>

                    {columns.map((col) => (
                      <td
                        key={col}
                        className={`data-cell ${isLast ? "highlight-cell" : ""}`}
                      >
                        {rowData[0]?.[col] ?? "-"}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>
    </Wrapper>
  );
}

export default TableComponent;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 0;
  background: transparent;
  display: flex;
  justify-content: center;
`;

const Card = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e6eef4;
  box-shadow: 0 3px 12px rgba(12, 60, 84, 0.06);
  padding: 0;
  overflow: hidden;
  font-family: Poppins, sans-serif;
  display: flex;
  flex-direction: column;

  .table-container {
    flex: 1;
    width: 100%;
    overflow: auto;
    display: flex;
    align-items: stretch;
  }

  .inventory-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    color: #111827;
    background: #ffffff;
    table-layout: fixed;
  }

  thead {
    background-color: #032b4e;
    color: #ffffff;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
  }

  th {
    padding: 12px 14px;
    text-align: center;
    font-size: 12px;
    vertical-align: middle;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    white-space: nowrap;
  }

  th:last-child {
    border-right: none;
  }

  .header-left {
    font-weight: 600;
    font-size: 12px;
    text-align: left;
    width: 40%;
    white-space: normal;
    line-height: 1.3;
    vertical-align: middle;
  }

  .header-cell {
    font-weight: 600;
    font-size: 12px;
  }

  tbody {
    background: #ffffff;
    font-family: Poppins, sans-serif;
    font-size: 13px;
    font-weight: 400;
    height: 100%;
  }

  tbody tr {
    border-bottom: 1px solid #e6eef4;
    transition: background-color 0.2s ease;
    height: 18%;
  }

  tbody tr:last-child {
    border-bottom: none;
  }

  tbody tr:hover {
    background-color: #f9fafb;
  }

  td {
    padding: 12px 14px;
    text-align: center;
    vertical-align: middle;
    border-right: 1px solid #e6eef4;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    font-family: Poppins, sans-serif;
  }

  td:last-child {
    border-right: none;
  }

  .row-title {
    font-weight: 600;
    color: #111827;
    text-align: left;
    font-size: 12px;
    line-height: 1.35;
    white-space: normal;
    width: 40%;
  }

  .data-cell {
    font-weight: 600;
  }

  /* last row subtle highlight like quantity row, but still flat */
  .highlight-row {
    background-color: #fff7ed;
  }

  .highlight-title {
    color: #E06639;
  }

  .highlight-cell {
    color: #E06639;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 12px 14px;
      font-size: 12px;
    }
  }
`;
